import React from "react";
import userLayouts from "../../../../constants/userLayoutsConsts";
import { routes } from "../../../../constants";
import { Navigate, Route } from "react-router-dom";
import { baseRouteMakerForSuperAdmin } from "../../../../constants/routeConsts";
import {
  ActiveSubscription,
  Addons,
  AddonsList,
  Ads,
  AdsList,
  AutoCredit,
  AutoCreditList,
  ChatConversation,
  ChatConversationChat,
  CouponCodeForm,
  CouponCodes,
  CustomerInfo,
  CustomerInfoAppointmentDetails,
  CustomerInfoAppointmentViewDetails,
  CustomerInfoDetails,
  CustomerInfoDetailsDetails,
  DiscountCodes,
  DiscountCodesForm,
  ElitePremium,
  Faqs,
  FineConfig,
  FineTransactionHistory,
  FlashMessageList,
  Free,
  InactiveSubscription,
  LoginAuth,
  LoginAuthDetails,
  Notify,
  OrganizationSponsorshipForm,
  OrganizationSponsorshipList,
  Payroll,
  Premium,
  PricingModel,
  Provider,
  ReferralCode,
  ReferralCodeList,
  Revenue,
  ReviewConfig,
  ReviewInfo,
  ServiceProvider,
  ServiceProviderAuth,
  ServiceProviderAuthDetails,
  ServiceProviderDetails,
  ServiceProviderDetailsAppointments,
  ServiceProviderDetailsDetails,
  ServiceProviderDetailsOffers,
  ServiceProviderDetailsPackages,
  ServiceProviderDetailsServices,
  ServiceProviderDetailsStaff,
  ServiceProviderSubscriptionPayment,
  Services,
  SubscriptionPlan,
  SubscriptionPlanList,
  SuperAdminDashboard,
  TermsAndConditions,
  TicketManagement,
  TicketManagementChat,
  TicketManagementDetails,
  User,
  UserPermissions,
  WalletManagement,
  WalletManagementForm,
  WalletTransactions,
  WalletsInfo,
} from "../../../../component/pages/super-admin";
import {
  Appointments,
  AppointmentsDetails,
  Configuration,
  ConfigurationList,
} from "../../../../component/pages/super-admin/modules/sales-page";
import ViewReview from "../../../../component/pages/super-admin/modules/reviews/view-review";
import UpdateSubcription from "../../../../component/pages/super-admin/modules/pro-membership/update-subscription";
import { Categories } from "../../../../component/pages/super-admin/modules/categories";

const renderSuperAdminProtectedRoutes = ({ layout }) => {
  switch (layout) {
    case userLayouts.IS_AUTH:
      return <></>;

    case userLayouts.IS_MAIN:
      return (
        <>
          <Route
            path="/"
            element={
              <Navigate
                to={baseRouteMakerForSuperAdmin(routes.SUPER_ADMIN_DASHBOARD)}
              />
            }
          />

          <Route
            path={routes.SUPER_ADMIN_DASHBOARD}
            element={<SuperAdminDashboard />}
          />

          {/* Customer DB module routes */}
          <Route path={routes.CUSTOMER_DB} element={ <Navigate to={baseRouteMakerForSuperAdmin(routes.CUSTOMER_INFO)} replace />}/>
          <Route path={routes.CUSTOMER_INFO} element={<CustomerInfo />}/>
          <Route path={routes.CUSTOMER_INFO_DETAILS} element={<CustomerInfoDetails />}>
              <Route path={routes.CUSTOMER_INFO_DETAILS_DETAILS} element={<CustomerInfoDetailsDetails />} />
              <Route path={routes.CUSTOMER_INFO_DETAILS_APPOINTMENTS} element={<CustomerInfoAppointmentDetails />} />
          </Route>
          <Route path={routes.CUSTOMER_INFO_DETAILS_APPOINTMENTS_VIEW} element={<CustomerInfoAppointmentViewDetails />} />

          {/* Service provider module routes */}
          <Route path={routes.SERVICE_PROVIDER} element={<ServiceProvider />} />
          <Route path={routes.SERVICE_PROVIDER_DETAILS} element={<ServiceProviderDetails />}>
              <Route path={routes.SERVICE_PROVIDER_DETAILS_DETAILS} element={<ServiceProviderDetailsDetails />} />
              <Route path={routes.SERVICE_PROVIDER_DETAILS_SERVICE_DETAILS} element={<ServiceProviderDetailsServices />} />
              <Route path={routes.SERVICE_PROVIDER_DETAILS_APPOINTMENT_DETAILS} element={<ServiceProviderDetailsAppointments />} />
              <Route path={routes.SERVICE_PROVIDER_DETAILS_SUBSCRIPTION_PAYMENT} element={<ServiceProviderSubscriptionPayment />} />
              <Route path={routes.SERVICE_PROVIDER_DETAILS_STAFF} element={<ServiceProviderDetailsStaff />} />
              <Route path={routes.SERVICE_PROVIDER_DETAILS_OFFERS} element={<ServiceProviderDetailsOffers />} />
              <Route path={routes.SERVICE_PROVIDER_DETAILS_PACKAGES} element={<ServiceProviderDetailsPackages />} />
          </Route>


          {/* Sales page module routes */}
          <Route
            path={routes.SALES_PAGE}
            element={
              <Navigate
                to={baseRouteMakerForSuperAdmin(routes.SALES_PAGE_APPOINTMENTS)}
                replace
              />
            }
          />
          <Route path={routes.SALES_PAGE_APPOINTMENTS} element={<Appointments />}/>
          <Route path={routes.SALES_PAGE_APPOINTMENTS_DETAILS} element={<AppointmentsDetails />}/>
          <Route path={routes.SALES_PAGE_CONFIGURATION} element={<Configuration />}/>
          <Route path={routes.SALES_PAGE_CONFIGURATION_LIST} element={<ConfigurationList />}/>

          {/* Ads and addons module routes */}
          <Route
            path={routes.ADS_AND_ADDONS}
            element={
              <Navigate to={baseRouteMakerForSuperAdmin(routes.ADS)} replace />
            }
          />
          <Route path={routes.ADS} element={<Ads />} />
          <Route path={routes.ADS_LIST} element={<AdsList />} />
          <Route path={routes.ADDONS} element={<Addons />} />
          <Route path={routes.ADDONS_LIST} element={<AddonsList />} />
          <Route
            path={routes.ORGANIZATION_SPONSORSHIP}
            element={<OrganizationSponsorshipList />}
          />
          <Route
            path={routes.ADD_ORGANIZATION_SPONSORSHIP}
            element={<OrganizationSponsorshipForm />}
          />

          {/* Requests module routes */}
          <Route
            path={routes.REQUESTS}
            element={
              <Navigate
                to={baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_AUTH)}
                replace
              />
            }
          />
          <Route
            path={routes.SERVICE_PROVIDER_AUTH}
            element={<ServiceProviderAuth />}
          />
          <Route
            path={routes.SERVICE_PROVIDER_AUTH_DETAILS}
            element={<ServiceProviderAuthDetails />}
          />

          {/* Chat access module routes */}
          <Route
            path={routes.CHAT_ACCESS}
            element={
              <Navigate
                to={baseRouteMakerForSuperAdmin(
                  routes.CHAT_ACCESS_CHAT_CONVERSATION
                )}
                replace
              />
            }
          />
          <Route
            path={routes.CHAT_ACCESS_CHAT_CONVERSATION}
            element={<ChatConversation />}
          />
          <Route
            path={routes.CHAT_ACCESS_CHAT_CONVERSATION_CHAT}
            element={<ChatConversationChat />}
          />

          {/* Requests module routes */}
          <Route path={routes.LOGIN_AUTH} element={<LoginAuth />} />
          <Route
            path={routes.LOGIN_AUTH_DETAILS}
            element={<LoginAuthDetails />}
          />

          {/* Reviews module routes */}
          <Route
            path={routes.REVIEWS}
            element={
              <Navigate
                to={baseRouteMakerForSuperAdmin(routes.REVIEW_INFO)}
                replace
              />
            }
          />

          {/* Review info module routes */}
          <Route path={routes.REVIEW_INFO} element={<ReviewInfo />} />
          <Route path={routes.VIEW_REVIEW_INFO} element={<ViewReview />} />
          <Route path={routes.REVIEW_CONFIG} element={<ReviewConfig />} />

          {/* Subscriptions module routes */}
          <Route
            path={routes.SUBSCRIPTIONS}
            element={
              <Navigate
                to={baseRouteMakerForSuperAdmin(routes.ACTIVE_SUBSCRIPTION)}
                replace
              />
            }
          />

          <Route
            path={routes.ACTIVE_SUBSCRIPTION}
            element={<ActiveSubscription />}
          />
          <Route
            path={routes.ACTIVE_SUBSCRIPTION_UPDATE}
            element={<UpdateSubcription />}
          />
          <Route
            path={routes.INACTIVE_SUBSCRIPTION}
            element={<InactiveSubscription />}
          />
          <Route
            path={routes.SUBSCRIPTION_PLAN}
            element={<SubscriptionPlan />}
          />

          {/* Elite premium module routes */}
          <Route path={routes.ELITE_PREMIUM} element={<ElitePremium />} />
          <Route path={routes.SUBSCRIPTION_PLAN_LIST} element={<SubscriptionPlanList />} />
          <Route path={routes.PREMIUM} element={<Premium />} />
          <Route path={routes.FREE} element={<Free />} />
          <Route path={routes.AUTO_CREDIT} element={<AutoCredit />} />
          <Route path={routes.AUTO_CREDIT_LIST} element={<AutoCreditList />} />

          {/* User management module routes */}
          <Route
            path={routes.USER_MANAGEMENT}
            element={
              <Navigate to={baseRouteMakerForSuperAdmin(routes.USER)} replace />
            }
          />

          {/* User module routes */}
          <Route path={routes.USER} element={<User />} />
          <Route path={routes.PROVIDER} element={<Provider />} />
          <Route path={routes.USER_MANAGEMENT_SERVICES} element={<Services />} />
          <Route path={routes.FINE_CONFIG} element={<FineConfig />} />
          <Route path={routes.FINE_TANSACTION_HISTORY} element={<FineTransactionHistory />} />

          {/* Fund management module routes */}
          <Route
            path={routes.FUND_MANAGEMENT}
            element={
              <Navigate
                to={baseRouteMakerForSuperAdmin(routes.REVENUE)}
                replace
              />
            }
          />

          {/* Revenue module routes */}
          <Route path={routes.REVENUE} element={<Revenue />} />

          {/* Payroll module routes */}
          <Route path={routes.PAYROLL} element={<Payroll />} />
          <Route path={routes.PRICING_MODEL} element={<PricingModel />} />

          {/* Wallet management module routes */}
          <Route
            path={routes.WALLET_MANAGEMENT}
            element={<WalletManagement />}
          />
          <Route
            path={routes.ADD_WALLET_MANAGEMENT}
            element={<WalletManagementForm />}
          />

          {/* Wallet transactions module routes */}
          <Route
            path={routes.WALLET_TRANSACTIONS}
            element={<WalletTransactions />}
          />

          {/* Wallets info module routes */}
          <Route path={routes.WALLETS_INFO} element={<WalletsInfo />} />

          {/* Faqs module routes */}
          <Route path={routes.FAQS} element={<Faqs />} />

          {/* Faqs module routes */}
          <Route path={routes.CATEGORIES} element={<Categories />} />

          {/* Flash message module routes */}
          <Route path={routes.FLASH_MESSAGE} element={<FlashMessageList />} />

          {/* Referral and discount codes module routes */}
          <Route
            path={routes.REFERRAL_AND_DISCOUNT_CODES}
            element={
              <Navigate
                to={baseRouteMakerForSuperAdmin(routes.REFERRAL_CODE)}
                replace
              />
            }
          />

          {/* Referral code module routes */}
          <Route path={routes.REFERRAL_CODE} element={<ReferralCode />} />
          <Route path={routes.REFERRAL_CODE_LIST} element={<ReferralCodeList />} />

          {/* Discount codes module routes */}
          <Route path={routes.DISCOUNT_CODES} element={<DiscountCodes />} />
          <Route
            path={routes.ADD_DISCOUNT_CODES}
            element={<DiscountCodesForm />}
          />

          {/* Terms and conditions module routes */}
          <Route
            path={routes.TERMS_AND_CONDITION}
            element={<TermsAndConditions />}
          />

          {/* Notify module routes */}
          <Route path={routes.NOTIFY} element={<Notify />} />

          {/* Ticket management module routes */}
          <Route
            path={routes.TICKET_MANAGEMENT}
            element={<TicketManagement />}
          />
          <Route
            path={routes.TICKET_MANAGEMENT_CHAT}
            element={<TicketManagementChat />}
          />
          <Route
            path={routes.TICKET_MANAGEMENT_DETAILS}
            element={<TicketManagementDetails />}
          />

          {/* Coupon Codes module routes */}
          <Route path={routes.COUPON_CODES} element={<CouponCodes />} />
          <Route path={routes.ADD_COUPON_CODES} element={<CouponCodeForm />} />

          {/* User permission module routes */}
          <Route path={routes.USER_PERMISSIONS} element={<UserPermissions />} />
        </>
      );

    default:
      return;
  }
};

export default renderSuperAdminProtectedRoutes;
